import constants, { isPatientApp } from './constants';

export const Links = {
  anleitung: {
    href: isPatientApp
      ? 'https://neolexon.de/wp-content/uploads/2021/04/gebrauchsanweisung-neolexon-aphasie-app.pdf'
      : 'https://neolexon.de/wp-content/uploads/2021/04/gebrauchsanweisung-neolexon-therapeuten-app.pdf',
    label: isPatientApp
      ? 'Anleitung Patient:innen App'
      : 'Anleitung Therapeut:innen App',
  },
  export: {
    href: `${constants.address}/settings/export`,
    label: 'Daten exportieren',
  },
  diga: {
    href: 'https://neolexon.de/kostenerstattung/aphasie-app-diga/',
    label: '',
  },
  impressum: {
    href: 'https://neolexon.de/impressum',
    label: 'Impressum',
  },
  datenschutz: {
    href: 'https://neolexon.de/datenschutzerklaerung',
    label: 'Datenschutz',
  },
  aphasieBrowserApp: {
    href: 'https://aphasie.neolexon.de',
    label: 'https://aphasie.neolexon.de',
  },
  therapistBrowserApp: {
    href: 'https://therapeut.neolexon.de',
    label: 'https://therapeut.neolexon.de',
  },
  agb: {
    href: 'https://neolexon.de/agb-neolexon-logopaedie-apps/',
    label: 'AGB',
  },
  nurEigentraining: {
    href: `${constants.therapistWebAppUrl}/?nur-eigentraining-einstellen`,
    label: 'Nur Eigentraining einstellen',
  },
  webApp: {
    href: `${constants.webAppUrl}`,
    label: '',
  },
  confidentiality: {
    href: 'https://neolexon.de/wp-content/uploads/schweigepflichtsentbindung_neolexon_aphasie.pdf',
    label: 'Schweigepflichtsentbindung',
  },
  buyingFormPatient: {
    href: 'https://neolexon.de/wp-content/uploads/bestellformular-neolexon-aphasie-patient.pdf',
    label: '',
  },
  license: {
    href:
      constants.environment === 'staging'
        ? 'https://app-staging.neolexon.de/plans/neolexon?cb'
        : 'https://app.neolexon.de/plans/neolexon?cb',
    label: '',
  },
  infoForTherapist: {
    href: 'https://neolexon.de/wp-content/uploads/2023/04/infoblatt-aerzte-aphasie-app-rezept-verordnen.pdf',
    label: 'Infoblatt für Ärzt:innen',
  },
  infoDischargeManagement: {
    href: 'https://neolexon.de/wp-content/uploads/neolexon_Aphasie_Infoblatt_Entlassmanagement.pdf',
    label: 'Infoblatt Entlassmanagement',
  },
};
